module.exports = __webpack_public_path__ + "img/noche-1.f4b5b24c.jpg";